export class Video {
    
    static cssClass = "c-video";
    video;
    
    constructor(el = null) {
        this.el = el;
        this.video = this.el.querySelector("video");
        this.init();
    }

    stop(){
        this.video.currentTime = 0;
    }

    play(){
        this.video.play();
    }

    pause(){
        this.video.pause();
    }

    init(){
        //Do something
    }
}